import React, { useEffect } from "react";
import DrawerApp from "@foundit/drawerApp";
import { clearSessionAndCookieItem, extractDomain } from "../utils/utils";

interface IProps {
  isOpen: boolean;
  handleClose: () => void;
  renderProfileImage: () => JSX.Element;
  userData: any;
  knowledgeHubUrl: string;
  shouldSendPrevUrl?: boolean;
}

const SideDrawer: React.FC<IProps> = ({
  isOpen,
  handleClose,
  renderProfileImage,
  userData,
  knowledgeHubUrl,
  shouldSendPrevUrl = true,
}) => {
  const logoutChannel = new BroadcastChannel("logout-channel");

  const options = [
    {
      label: "Access & Settings",
      Icon: <div className="RecHeaderSprite icons settings" />,
      url: `${extractDomain()}/edge/user-management/?tab=manageUsers`,
    },
    {
      label: "Feedback",
      Icon: <div className="RecHeaderSprite icons message" />,
      url: `${extractDomain()}/v2/feedback.html`,
    },
    {
      label: "FAQ",
      Icon: <div className="RecHeaderSprite icons notification" />,
      url: `${knowledgeHubUrl}#category`,
    },
  ];

  const handleLogout = () => {
    const keysToClear = [
      "chatCount",
      "chatServiceEnabled",
      "lastChatFetchTime",
      "userDetails",
      "initialVisit",
      "SESSION_STORAGE_SUBUID",
      "CLEVERTAP_PAGE_TRACKING",
      "dowdowloadsData",
      "dowloadsData",
      "alreadyDownloaded",
      "downloadsInProgress",
      "C",
      "persist:root",
      "searchMode",
    ];

    keysToClear.forEach(clearSessionAndCookieItem);
    localStorage.removeItem("downloadLeader");
    localStorage.removeItem("sessionId");
    localStorage.removeItem("downloadIntent");

    logoutChannel.postMessage({ type: "LOGOUT" });
    window.location.href = `${extractDomain()}/v2/logout.html`;
  };

  useEffect(() => {
    logoutChannel.onmessage = (event) => {
      if (event.data?.type === "LOGOUT") {
        const keysToClear = [
          "chatCount",
          "chatServiceEnabled",
          "lastChatFetchTime",
          "userDetails",
          "initialVisit",
          "SESSION_STORAGE_SUBUID",
          "CLEVERTAP_PAGE_TRACKING",
          "dowdowloadsData",
          "dowloadsData",
          "alreadyDownloaded",
          "downloadsInProgress",
          "C",
        ];
        keysToClear.forEach(clearSessionAndCookieItem);
        localStorage.removeItem("downloadLeader");
        localStorage.removeItem("sessionId");
        localStorage.removeItem("downloadIntent");

        setTimeout(() => {
          if(shouldSendPrevUrl){
            window.location.href = `${extractDomain()}?prevUrl=${encodeURIComponent(window.location.href)}`;
          }else{
            window.location.href = `${extractDomain()}`;
          }
        }, 100);
      }
    };

    return () => logoutChannel.close();
  }, []);

  useEffect(() => {
    const handleEscapeKey = (event: KeyboardEvent) => {
      if (event.key === "Escape" && isOpen) {
        handleClose();
      }
    };

    if (isOpen) {
      document.addEventListener("keydown", handleEscapeKey);
    }

    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [isOpen, handleClose]);

  return (
    <DrawerApp
      isOpen={isOpen}
      onClose={handleClose}
      styles={{ backgroundColor: "#FFFFFF", width: "360px" }}
    >
      {isOpen ? (
        <div className="rec_header_up_drawer_wrapper">
          <div className="rec_header_up_drawer_upper_sec">
            <div className="rec_header_up_drawer_ud">
              {/* Avatar + Name  */}
              <div className="rec_header_up_drawer_ud_name">
                <div className="rec_header_up_img_wrapper">
                  {renderProfileImage()}
                </div>
                <span className="rec_header_up_drawer_ud_name">
                  {userData?.name ? userData.name : userData?.username}
                </span>
              </div>

              {/* Other Details  */}
              <div className="rec_header_up_drawer_ud_other">
                {/* Phone  */}
                <div className="rec_header_up_drawer_ud_other_opt">
                  <div
                    className="RecHeaderSprite icons phone_black"
                    style={{
                      height: "20px",
                      width: "20px",
                      transform: "scale(0.70)",
                    }}
                  />
                  {userData?.mobile || "N/A"}
                </div>

                {/* Email  */}
                <div className="rec_header_up_drawer_ud_other_opt">
                  <div
                    className="RecHeaderSprite icons email_black"
                    style={{
                      height: "20px",
                      width: "22px",
                      transform: "scale(0.70)",
                    }}
                  />
                  {userData?.email || "N/A"}
                </div>
              </div>
            </div>

            {/* Options  */}
            <div className="rec_header_up_drawer_options">
              {options?.map(({ Icon, label, url }, index) => {
                return (
                  <React.Fragment key={`ud_options_${index}`}>
                    <a className="rec_header_up_drawer_option" href={url}>
                      {Icon}
                      {label}
                    </a>
                  </React.Fragment>
                );
              })}
            </div>
          </div>

          {/* Log out  */}
          <div className="rec_header_up_drawer_footer" onClick={handleLogout}>
            <div className="RecHeaderSprite icons log_out" />
            <span>Logout</span>
          </div>
        </div>
      ) : null}
    </DrawerApp>
  );
};

export default SideDrawer;
